// extracted by mini-css-extract-plugin
module.exports = {"table-row-active":"index_table-row-active__3kCsU","loading":"index_loading__AEXI1"};